import { render, staticRenderFns } from "./SvgLegend.vue?vue&type=template&id=53df9360&scoped=true"
import script from "./SvgLegend.vue?vue&type=script&lang=js"
export * from "./SvgLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53df9360",
  null
  
)

export default component.exports